export const showLoader = (id) => {
  $(id).attr('aria-busy', 'true')
  $(id).removeAttr('hidden')
}

export const hideLoader = (id) => {
  $(id).attr('aria-busy', 'false')
  $(id).attr('hidden', '')
}
